import { MarvColor, MarvColorBlue, MarvColorGreen, MarvColorPurple, MarvColorPrimary, MarvColorSecondary } from '@marv/types';
import { MarvDateService } from '@marv/services';
import { environment } from '@app/environment';
import { StoreDashboard } from '@app/models';
import { OperationItem, MissionDetails, RetailerLogo } from '@app/components';

export class StoreDetailsTypeOfMissionKpis {
    code: string;
    name: string;    
}

export class StoreDetailsKpis {
    label: string;
    value: any;
    color: MarvColor = MarvColorPrimary;
    constructor(label: string, value: any, color: MarvColor = MarvColorPrimary){
        this.label = label;
        this.value = value;
        this.color = color;
    }
}

export class StoreDetailsOperationsKpis {
    typeOfMission: StoreDetailsTypeOfMissionKpis;
    kpis: Array<StoreDetailsKpis> = [];
}

export class StoreDetailsInfos{
    
    id: number;
    name: string;
    retailer: string;
    logoRetailer: RetailerLogo;
    address: string
    administrativeArea: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
    customerAreaName: string|null;
    customerSectorName: string|null;
    
    showKpis: boolean = true;
    operationsKpis: Array<StoreDetailsOperationsKpis> = [];
    
    showOperations: boolean = true;
    operations: Array<OperationItem> = [];
    
    static FromStoreDashboard(storeDashboard: StoreDashboard): StoreDetailsInfos{
        let store = storeDashboard.store;
        let storeDetailsInfos = new StoreDetailsInfos();
        storeDetailsInfos.id = store.id;
        storeDetailsInfos.name = store.name;
        storeDetailsInfos.retailer = store.retailerName;
        storeDetailsInfos.logoRetailer = new RetailerLogo(store.retailerName);
        storeDetailsInfos.address = store.address?.line1;
        storeDetailsInfos.administrativeArea = store.address?.administrativeArea;
        storeDetailsInfos.zipCode = store.address?.zipCode;
        storeDetailsInfos.city = store.address?.city;
        storeDetailsInfos.latitude = store.address?.lat;
        storeDetailsInfos.longitude = store.address?.lon;     
        // A MODIFIER - Récupérer via l'API un tableau de régions / secteurs par opération
        storeDetailsInfos.customerSectorName = store.customersectorName;
        storeDetailsInfos.customerAreaName = store.customerAreaName;
        
        // A MODIFIER - Gestion des KPI's magasin ---------------------------------
        /*let nbDays =  Math.floor(Math.random() * (20 - 5) + 5);
        let tauxPrésence =  Math.floor(Math.random() * (100 - 90) + 90);
        let nbVentes =  nbDays * Math.floor(Math.random() * (20 - 5) + 5);
        let tauxConversion =  Math.floor(Math.random() * (90 - 65) + 65);
        let animationKpis: StoreDetailsOperationsKpis = {
            typeOfMission: {code : 'ANIM', name: 'Animation'},
            kpis: [
                new StoreDetailsKpis('Nb jours réalisés', nbDays, MarvColorSecondary),
                new StoreDetailsKpis('Taux de présence', tauxPrésence+'%', MarvColorSecondary),
                new StoreDetailsKpis('Nb de ventes', nbVentes, MarvColorSecondary),
                new StoreDetailsKpis('Ventes moyenne / jour', Math.round(nbVentes/nbDays), MarvColorSecondary),
                new StoreDetailsKpis('Tx de conversion (ventes/contacts)', tauxConversion+'%', MarvColorSecondary)
            ]
        }
        let nbMissions = Math.floor(Math.random() * (15 - 5) + 5);
        let averageMinutes = (Math.random() * (300 - 60) + 60);
        let nbMinutes = nbMissions * averageMinutes;
        let budget = Math.round(nbMissions * Math.floor(Math.random() * (150 - 90) + 90));
        let score =  Math.floor(Math.random() * (95 - 45) + 45) / 100;
        let merchKpis: StoreDetailsOperationsKpis = {
            typeOfMission: {code : 'MERCH_HORAIRE', name: 'Merch Horaire'},
            kpis: [
                new StoreDetailsKpis('Nb d\'heures réalisées', MarvDateService.MinutesToStr(nbMinutes, 'H'), MarvColorSecondary),
                new StoreDetailsKpis('Moyenne par intervention', MarvDateService.MinutesToStr(averageMinutes, 'H'), MarvColorSecondary),
                new StoreDetailsKpis('Budget', budget+'€', MarvColorSecondary),
                new StoreDetailsKpis('Score Merch', score, MarvColorSecondary),
            ]
        }        
        storeDetailsInfos.operationsKpis = [animationKpis, merchKpis];
        */
        // ----------------------------------------------
        
        let operations: Array<OperationItem> = [];
        for(let o of storeDashboard.operationActivityReports){
            operations.push(OperationItem.FromStoreDashOperation(o));
        }
        storeDetailsInfos.operations = operations;
        
        return storeDetailsInfos;
    }
    
    
    static FromMissionDetails(m: MissionDetails): StoreDetailsInfos{
        let storeDetailsInfos = new StoreDetailsInfos();
        storeDetailsInfos.id = m.store.id;
        storeDetailsInfos.name = m.store.name;
        storeDetailsInfos.retailer = m.retailer.name;
        storeDetailsInfos.logoRetailer = new RetailerLogo(m.retailer.name);
        storeDetailsInfos.address = m.store.line1;
        storeDetailsInfos.administrativeArea = m.store.administrativeArea;
        storeDetailsInfos.zipCode = m.store.zipCode;
        storeDetailsInfos.city = m.store.city;
        storeDetailsInfos.latitude = m.store.lat;
        storeDetailsInfos.longitude = m.store.lon; 
        storeDetailsInfos.customerSectorName = m.customerSector.name;
        storeDetailsInfos.customerAreaName = m.customerArea.name;
        storeDetailsInfos.showKpis = false;
        storeDetailsInfos.showOperations = false;
        return storeDetailsInfos;
    }
}
